import React, {Component} from 'react';
import '../../style.css';
import {
    Button,
    Card,
    DatePicker,
    Dropdown,
    Form,
    Input,
    Menu,
    message,
    Modal,
    Radio,
    Space,
    Table,
    Typography,
    PageHeader
} from "antd";
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import moment from "moment";
import FileViewer from 'react-file-viewer';
const { Column } = Table;
const { Paragraph } = Typography;

class StaffRoster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company:[],
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            staffData:[],
            edit_visible:false,//编辑弹窗状态
            add_visible:false,//添加公司弹窗状态
            delete_visible:false,//删除弹窗状态
            deleteId: 0,//待删除人员Id
            editId: 0,//待修改人员Id
            allNum:'',
            tecNum:'',
            percentage:'',
            name:"",
            idNumber:"",
            title:"",
            education:"请选择学历",
            school:"",
            major:"",
            startTime:"",
            endTime:"",
            department:"",
            post:"",
            isTechnology:"",
            // isInsured:"",
            // isPartTime:"",
            // isTemporary:"",
            // isRetire:"",
            // isNcms:'',
            //isNew:"",
            //isResearcher:'',
            newName:"",
            newIdNumber:"",
            newTitle:"",
            newEducation:"",
            newSchool:"",
            newMajor:"",
            newStartTime:"",
            newEndTime:"",
            newDepartment:"",
            newPost:"",
            newIsTechnology:"",
            // newIsInsured:"",
            // newIsPartTime:"",
            // newIsTemporary:"",
            // newIsRetire:"",
            // newIsNcms:'',
            //newIsNew:"",
            //newIsResearcher:"",
            fileStream:'',
            preview_visible:false,
            ifHaveMajor:true,
            ifHaveMajorNew:true,
            loading:false,
            fileField:[],
            flag:true,
            Uploading:false,
        }
        this.handleAdd = this.handleAdd.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.addStaff = this.addStaff.bind(this);
        this.uploadStaff = this.uploadStaff.bind(this);
        this.deleteStaff = this.deleteStaff.bind(this);
        this.nameChange = this.nameChange.bind(this);
        this.idNumberChange = this.idNumberChange.bind(this);
        this.titleChange = this.titleChange.bind(this);
        this.educationChange = this.educationChange.bind(this);
        this.schoolChange = this.schoolChange.bind(this);
        this.majorChange = this.majorChange.bind(this);
        this.startTimeChange = this.startTimeChange.bind(this);
        this.endTimeChange = this.endTimeChange.bind(this);
        this.departmentChange = this.departmentChange.bind(this);
        this.postChange = this.postChange.bind(this);
        this.isTechnologyChange = this.isTechnologyChange.bind(this);
        // this.isInsuredChange = this.isInsuredChange.bind(this);
        // this.isPartTimeChange = this.isPartTimeChange.bind(this);
        // this.isTemporaryChange = this.isTemporaryChange.bind(this);
        // this.isRetireChange = this.isRetireChange.bind(this);
        //this.isNewChange = this.isNewChange.bind(this);
        // this.isNcmsChange = this.isNcmsChange.bind(this);
        //this.isResearcherChange = this.isResearcherChange.bind(this);
        this.nameChangeNew = this.nameChangeNew.bind(this);
        this.idNumberChangeNew = this.idNumberChangeNew.bind(this);
        this.titleChangeNew = this.titleChangeNew.bind(this);
        this.educationChangeNew = this.educationChangeNew.bind(this);
        this.schoolChangeNew = this.schoolChangeNew.bind(this);
        this.majorChangeNew = this.majorChangeNew.bind(this);
        this.startTimeChangeNew = this.startTimeChangeNew.bind(this);
        this.endTimeChangeNew = this.endTimeChangeNew.bind(this);
        this.departmentChangeNew = this.departmentChangeNew.bind(this);
        this.postChangeNew = this.postChangeNew.bind(this);
        this.isTechnologyChangeNew = this.isTechnologyChangeNew.bind(this);
        // this.isInsuredChangeNew = this.isInsuredChangeNew.bind(this);
        // this.isPartTimeChangeNew = this.isPartTimeChangeNew.bind(this);
        // this.isTemporaryChangeNew = this.isTemporaryChangeNew.bind(this);
        // this.isRetireChangeNew = this.isRetireChangeNew.bind(this);
        //this.isNewChangeNew = this.isNewChangeNew.bind(this);
        // this.isNcmsChangeNew = this.isNcmsChangeNew.bind(this);
        //this.isResearcherChangeNew = this.isResearcherChangeNew.bind(this);
    }
    componentDidMount() {
        this.setState(()=>({
            loading:true
        }))
        //获取人员列表
        fetchPost(global.constants.getStaffRosterGetL,{companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            staffData:res.data,
                            loading:false
                        }))
                    }
                    else{
                        this.setState(()=>({
                            loading:false
                        }))
                        message.info("该公司还没有录入员工名单，请先添加员工！").then()
                    }
                }
            )
        fetchPost(global.constants.getStaffRosterRemarkL,{companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            allNum:res.data.allNum,
                            tecNum:res.data.tecNum,
                            percentage:res.data.percentage
                        }))
                    }
                }
            )
        fetchPost(global.constants.getCompany,{id:this.state.companyId})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            company:res.data
                        }))
                    }else{
                        message.info(res.msg).then();
                    }
                }
            )
    }
    handleDelete= (e) =>{
        //确定删除弹窗
        const value = e.id;
        this.setState(()=>({
            delete_visible:true,
            deleteId:value,
        }))
    }
    handleExportClick(){
        fetchPost(global.constants.exportStaffRosterL, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/2-17人员花名册.doc',
            fileName: '人员花名册.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '2-17人员花名册.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-17人员花名册.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/人员花名册.pdf',
                            fileName: '人员花名册.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    deleteStaff(){
        fetchPost(global.constants.deleteStaffRoster,{id:this.state.deleteId})
            .then(
                res => {
                    if(res.code === 200){
                        message.success('删除公司人员成功').then();
                        this.setState(()=>({
                            delete_visible:false
                        }))
                        fetchPost(global.constants.getStaffRosterGetL,{companyId: this.state.companyId})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            staffData:res.data,
                                        }))
                                    }else{
                                        this.setState(()=>({
                                            staffData:[],
                                        }))
                                    }
                                }
                            )//更新后重新获取
                        }
                    else{
                        message.info("删除失败").then()
                    }
                }
            )
    }
    hideModal(){
        this.setState({
            add_visible:false,
            edit_visible:false,
            delete_visible:false,
            preview_visible:false,
        });
    }
    handleAdd(){
        //打开添加公司弹窗
        this.setState(()=>({
            add_visible:true,
            name:"",
            idNumber:"",
            title:"",
            education:"请选择学历",
            school:"",
            major:"",
            startTime:"",
            endTime:"",
            department:"",
            post:"",
            isTechnology:"",
            // isInsured:"",
            // isPartTime:"",
            // isTemporary:"",
            // isRetire:"",
            // isNcms:'',
            //isNew:"",
            //isResearcher:"",
        }))
    };
    addStaff(){
        if(this.state.idNumber.length !== 18){
            message.info("请检查身份证号是否正确").then()
        }else{
            if(this.state.name === ''||this.state.idNumber === ''||this.state.title=== ''||
                this.state.education === '请选择学历'||this.state.school === ''||
                (this.state.ifHaveMajor === true &&this.state.major === '')||
                this.state.startTime === ''||this.state.endTime === ''||this.state.department === ''
                ||this.state.post === ''||this.state.isTechnology === ''){
                message.info("请检查人员信息是否填写完整").then()
            }else{
                fetchPost(global.constants.addStaffRoster, {
                    companyId:this.state.companyId,
                    name:this.state.name,
                    idNumber: this.state.idNumber,
                    title: this.state.title,
                    education: this.state.education,
                    school:this.state.school,
                    major: this.state.major,
                    startTime: this.state.startTime,
                    endTime: this.state.endTime,
                    department: this.state.department,
                    post: this.state.post,
                    isTechnology:this.state.isTechnology,
                    // isInsured: this.state.isInsured,
                    // isPartTime: this.state.isPartTime,
                    // isTemporary: this.state.isTemporary,
                    // isRetire:this.state.isRetire,
                    // isNcms:this.state.isNcms,
                    //isNew:this.state.isNew,
                    //isResearcher:this.state.isResearcher,
                })
                    .then(
                        res => {
                            if (res.code === 200) {
                                message.success('添加人员成功').then();
                                this.setState(() => ({
                                    add_visible: false
                                }))
                                fetchPost(global.constants.getStaffRosterGetL, {companyId:this.state.companyId})
                                    .then(
                                        res => {
                                            if (res.code === 200) {
                                                this.setState(() => ({
                                                    staffData: res.data,
                                                }))
                                            }
                                        }
                                    )//更新后重新获取
                                fetchPost(global.constants.getStaffRosterRemarkL,{companyId: this.state.companyId})
                                    .then(
                                        res => {
                                            if(res.code === 200) {
                                                this.setState(()=>({
                                                    allNum:res.data.allNum,
                                                    technology:res.data.technology,
                                                    percentage:res.data.percentage
                                                }))
                                            }
                                        }
                                    )
                            } else {
                                if (res.code === -1) {
                                    message.error("插入失败，该员工已存在！").then()
                                }
                                if (res.code === -2) {
                                    //console.log("插入失败，数据库异常！")
                                }
                            }
                        }
                    )
            }
        }

        }
    handleEdit= (e) =>{
        //打开编辑弹窗
        const value = e.id;
        this.setState(()=>({
            editId:value,
        }))
        fetchPost(global.constants.StaffRosterGetOneL, {id:value})
            .then(
                res =>{
                    if(res.code === 200){
                        this.setState(()=>({
                            newName: res.data.name,
                            newIdNumber:res.data.idNumber,
                            newTitle:res.data.title,
                            newEducation:res.data.education,
                            newSchool:res.data.school,
                            newMajor:res.data.major,
                            newStartTime:res.data.startTime,
                            newEndTime:res.data.endTime,
                            newDepartment:res.data.department,
                            newPost:res.data.post,
                            newIsTechnology:res.data.isTechnology,
                            // newIsInsured:res.data.isInsured,
                            // newIsPartTime:res.data.isPartTime,
                            // newIsTemporary:res.data.isTemporary,
                            // newIsRetire:res.data.isRetire,
                            // newIsNcms:res.data.isNcms,
                            //newIsNew:res.data.isNew,
                            //newIsResearcher:res.data.isResearcher,
                            edit_visible:true,
                        }))
                    }
                }
            )
    }
    uploadStaff(){
        if(this.state.newIdNumber.length !== 18){
            message.info("请检查身份证号是否正确").then()
        }else{
            let params = {
                id:this.state.editId,
                companyName: this.state.companyName,
                name:this.state.newName,
                idNumber: this.state.newIdNumber,
                title: this.state.newTitle,
                education: this.state.newEducation,
                school:this.state.newSchool,
                major: this.state.newMajor,
                startTime: this.state.newStartTime,
                endTime: this.state.newEndTime,
                department: this.state.newDepartment,
                post: this.state.newPost,
                isTechnology:this.state.newIsTechnology,
                // isInsured: this.state.newIsInsured,
                // isPartTime: this.state.newIsPartTime,
                // isTemporary: this.state.newIsTemporary,
                // isRetire:this.state.newIsRetire,
                // isNcms:this.state.newIsNcms,
                //isNew:this.state.newIsNew,
                //isResearcher:this.state.newIsResearcher,
            }
            fetchPost(global.constants.updateStaffRoster, params)
                .then(
                    res => {
                        console.log(res)
                        if(res.code === 200){
                            message.success("修改成功！").then();
                            this.setState(()=>({
                                edit_visible:false
                            }))
                            fetchPost(global.constants.getStaffRosterGetL,{companyId:this.state.companyId})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                staffData:res.data,
                                            }))
                                        }
                                    }
                                )//更新后重新获取
                        }
                        else{
                            message.error("修改失败").then()
                        }

                    }
                )
        }
    }
    downloadTemplate(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/templates/人员花名册.xlsx',
            fileName: '人员花名册.xlsx'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '人员花名册.xlsx';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    fileInput(){
        this.setState(()=>({
            fileField:document.querySelector("input[type='file'][name='file']"),
            flag:false
        }))
    }
    importStaff(){
        const formdata = new FormData();
        formdata.append('file', this.state.fileField.files[0]);
        formdata.append('companyId',this.state.companyId);
        formdata.append('projectId',0);
        formdata.append('productId',0);
        formdata.append('patentId',0);
        formdata.append('otherId',0);
        formdata.append('remark',"人员花名册");
        fetch(global.constants.importStaff, {
            method: 'POST',
            body: formdata,
            mode: 'cors',
            credentials: 'include',
        })
            .then(res => res.json())
            .then(
                res => {
                    if (res.code === 200) {
                        message.success("导入成功").then()
                        fetchPost(global.constants.getStaffRosterGetL,{companyId:this.state.companyId})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            staffData:res.data,
                                        }))
                                    }
                                }
                            )//导入后重新获取
                    }else{message.error("导入失败，请检查模板内容并重新导入").then()}
                }
            )
    }
    render() {
        const education_menu = (
            <Menu>
                <Menu.Item onClick={this.educationChange.bind(this,'博士')}>
                   博士
                </Menu.Item>
                <Menu.Item onClick={this.educationChange.bind(this,'硕士')}>
                    硕士
                </Menu.Item>
                <Menu.Item onClick={this.educationChange.bind(this,'本科')}>
                    本科
                </Menu.Item>
                <Menu.Item onClick={this.educationChange.bind(this,'大专')}>
                    大专
                </Menu.Item>
                <Menu.Item onClick={this.educationChange.bind(this,'中专')}>
                    中专
                </Menu.Item>
                <Menu.Item onClick={this.educationChange.bind(this,'高中')}>
                    高中
                </Menu.Item>
                <Menu.Item onClick={this.educationChange.bind(this,'初中')}>
                    初中
                </Menu.Item>
            </Menu>
        )
        const education_menu_new = (
            <Menu>
                <Menu.Item onClick={this.educationChangeNew.bind(this,'博士')}>
                    博士
                </Menu.Item>
                <Menu.Item onClick={this.educationChangeNew.bind(this,'硕士')}>
                    硕士
                </Menu.Item>
                <Menu.Item onClick={this.educationChangeNew.bind(this,'本科')}>
                    本科
                </Menu.Item>
                <Menu.Item onClick={this.educationChangeNew.bind(this,'大专')}>
                    大专
                </Menu.Item>
                <Menu.Item onClick={this.educationChangeNew.bind(this,'中专')}>
                    中专
                </Menu.Item>
                <Menu.Item onClick={this.educationChangeNew.bind(this,'高中')}>
                    高中
                </Menu.Item>
                <Menu.Item onClick={this.educationChangeNew.bind(this,'初中')}>
                    初中
                </Menu.Item>
            </Menu>
        );
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="人员花名册"
                        extra={[
                            <Button
                                onClick={this.downloadTemplate.bind(this)}>下载模板</Button>,
                            <input type="file" name='file' onChange={this.fileInput.bind(this)}/>,
                            <Button
                                type="primary"
                                onClick={this.importStaff.bind(this)} disabled={this.state.flag}>导入</Button>,
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Button
                                type="primary"
                                onClick={this.handlePreviewClick.bind(this)}
                            >预览</Button>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <Paragraph>
                    <pre>注：公司共有员工{this.state.allNum}人，公司科技人员{this.state.tecNum}人，占员工总数的{this.state.percentage}%。</pre>
                </Paragraph>
                <Space direction="vertical" className="content-style" >
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.staffData} loading={this.state.loading} size={'small'} scroll={{ x: 1300 }} onHeaderRow={()=>{return{className:"list-column-style"}}}>
                            <Column
                                align="center"
                                title={<p className="list-column-style">序号</p>}
                                fixed='left'
                                width={50}
                                render={
                                    (text,record,index)=>(`${index+1}`)} />
                            <Column
                                align="center"
                                title={<p className="list-column-style">姓名</p>}
                                dataIndex="name"
                                key="name"
                                fixed='left'
                                width={100}
                            />
                            <Column
                                align="center"
                                title={<p className="list-column-style">身份证号</p>}
                                dataIndex="idNumber"
                                key="idNumber"
                                fixed='left'
                                width={200}
                            />
                            {
                                (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区")&&
                            <Column
                                align="center"
                                title={<p className="list-column-style">职称</p>}
                                dataIndex="title"
                                key="title" />
                            }
                            <Column
                                align="center"
                                title={<p className="list-column-style">学历</p>}
                                dataIndex="education"
                                key="education" />
                            {
                                (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区")&&
                                <Column
                                    align="center"
                                    title={<p className="list-column-style">毕业院校</p>}
                                    dataIndex="school"
                                    key="school" />
                            }
                            {
                                (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区")&&
                                <Column
                                    align="center"
                                    title={<p className="list-column-style">专业</p>}
                                    dataIndex="major"
                                    key="major" />
                            }
                            {
                                (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区")&&
                                <Column
                                    align="center"
                                    title={<p className="list-column-style">劳动合同起止时间</p>}
                                    render={
                                        (text,record)=>(<div>{record.startTime}-{record.endTime}</div>)}
                                    key="time" />
                            }
                            <Column
                                align="center"
                                title={<p className="list-column-style">所在部门</p>}
                                dataIndex="department"
                                key="department" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">工作岗位</p>}
                                dataIndex="post"
                                key="post" />
                            {
                                (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区")&&
                                <Column
                                    align="center"
                                    title={<p className="list-column-style">是否科技人员</p>}
                                    dataIndex="isTechnology"
                                    key="isTechnology" />
                            }
                            <Column
                                align="center"
                                title={<p className="list-column-style">操作</p>}
                                key="action"
                                fixed='right'
                                width={200}
                                render={(text, record) => (
                                    <Space size="middle">
                                        <Button
                                            type="primary"
                                            icon={<EditOutlined />}
                                            onClick={this.handleEdit.bind(this,record)}
                                        >编辑</Button>
                                        <Button
                                            type="primary"
                                            icon={<DeleteOutlined />}
                                            onClick={this.handleDelete.bind(this,record)}
                                        >删除</Button>
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                    <div className="upload-button">
                        <Button
                            type="primary"
                            onClick={this.handleAdd}
                        >
                            添加人员
                        </Button>
                    </div>
                </Space>
                <Modal
                    visible={this.state.edit_visible}
                    title={'修改人员信息'}
                    onOk={this.uploadStaff}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.uploadStaff}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item label="姓名" name="newName">
                            <Input
                                defaultValue={this.state.newName}
                                onChange={(e) => this.nameChangeNew(e.target.value)}/></Form.Item>
                        <Form.Item label="身份证号" name="newIdNumber">
                            <Input defaultValue={this.state.newIdNumber} onChange={(e) => this.idNumberChangeNew(e.target.value)}/>
                        </Form.Item>
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="职称" name="newTitle">
                                <Input defaultValue={this.state.newTitle}
                                       onChange={(e) => this.titleChangeNew(e.target.value)}/>
                            </Form.Item>
                        }
                        <Form.Item label="学历" name="newEducation">
                            <Dropdown overlay={education_menu_new} placement="bottomCenter" arrow trigger='click'>
                                <Button type="primary" style={{marginRight:5}}>{this.state.newEducation} </Button>
                            </Dropdown>
                        </Form.Item>
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="毕业院校" name="newSchool">
                                <Input defaultValue={this.state.newSchool}
                                       onChange={(e) => this.schoolChangeNew(e.target.value)}/></Form.Item>
                        }
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="专业" name="newMajor">
                                <Input disabled={!this.state.ifHaveMajorNew} defaultValue={this.state.newMajor}
                                       onChange={(e) => this.majorChangeNew(e.target.value)}/></Form.Item>
                        }
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="劳动合同开始时间" name="newStartTime">
                                <Space direction="vertical" size={12}>
                                    <DatePicker
                                        format={'YYYY.MM.DD'}
                                        defaultValue={moment(this.state.newStartTime)}
                                        onChange={this.startTimeChangeNew}
                                    />
                                </Space>
                            </Form.Item>
                        }
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="劳动合同结束时间" name="newEndTime">
                                <Space direction="vertical" size={12}>
                                    <DatePicker
                                        format={'YYYY.MM.DD'}
                                        defaultValue={moment(this.state.newEndTime)}
                                        onChange={this.endTimeChangeNew}
                                    />
                                </Space>
                            </Form.Item>
                        }
                        <Form.Item label="所在部门" name="newDepartment">
                            <Input defaultValue={this.state.newDepartment} onChange={(e) => this.departmentChangeNew(e.target.value)}/></Form.Item>
                        <Form.Item label="工作岗位" name="newPost">
                            <Input defaultValue={this.state.newPost} onChange={(e) => this.postChangeNew(e.target.value)}/></Form.Item>
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="是否科技人员" name="newIsTechnology">
                                <Radio.Group name="radiogroup"
                                             defaultValue={this.state.newIsTechnology}
                                             onChange={(e) => this.isTechnologyChangeNew(e.target.value)}>
                                    <Radio value={"是"}>是</Radio>
                                    <Radio value={"否"}>否</Radio>
                                </Radio.Group>
                            </Form.Item>
                        }
                        {/*<Form.Item label="是否参加社保" name="newIsInsured">*/}
                        {/*    <Radio.Group name="radiogroup"*/}
                        {/*                 defaultValue={this.state.newIsInsured}*/}
                        {/*                 onChange={(e) => this.isInsuredChangeNew(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否兼职人员" name="newIsPartTime">*/}
                        {/*    <Radio.Group name="radiogroup"*/}
                        {/*                 defaultValue={this.state.newIsPartTime}*/}
                        {/*                 onChange={(e) => this.isPartTimeChangeNew(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否临时聘用人员" name="newIsTemporary">*/}
                        {/*    <Radio.Group name="radiogroup"*/}
                        {/*                 defaultValue={this.state.newIsTemporary}*/}
                        {/*                 onChange={(e) => this.isTemporaryChangeNew(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否退休返聘人员" name="newIsRetire">*/}
                        {/*    <Radio.Group name="radiogroup"*/}
                        {/*                 defaultValue={this.state.newIsRetire}*/}
                        {/*                 onChange={(e) => this.isRetireChangeNew(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否参加新农合" name="newIsNcms">*/}
                        {/*    <Radio.Group name="radiogroup"*/}
                        {/*                 defaultValue={this.state.newIsNcms}*/}
                        {/*                 onChange={(e) => this.isNcmsChangeNew(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否是新员工" name="newIsNew">*/}
                        {/*    <Radio.Group name="radiogroup"*/}
                        {/*                 defaultValue={this.state.newIsNew}*/}
                        {/*                 onChange={(e) => this.isNewChangeNew(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否是研究开发人员" name="newIsResearcher">*/}
                        {/*    <Radio.Group name="radiogroup"*/}
                        {/*                 defaultValue={this.state.newIsResearcher}*/}
                        {/*                 onChange={(e) => this.isResearcherChangeNew(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.add_visible}
                    title={'添加公司人员'}
                    onOk={this.addStaff}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.addStaff}>
                            提交
                        </Button>,
                    ]}
                >
                    <Paragraph>
                        <pre>注：若无职称，可填”无“或者”/“</pre>
                    </Paragraph>
                    <Form>
                        <Form.Item label="姓名" name="name" rules={[{ required: true, message: '请输入姓名!' }]}>
                            <Input onChange={(e) => this.nameChange(e.target.value)}/></Form.Item>
                        <Form.Item label="身份证号" name="idNumber" rules={[{ required: true, message: '请输入身份证号!' }]}>
                            <Input onChange={(e) => this.idNumberChange(e.target.value)}/>
                        </Form.Item>
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="职称" name="title" rules={[{required: true, message: '请输入职称！'}]}>
                                <Input onChange={(e) => this.titleChange(e.target.value)}/>
                            </Form.Item>
                        }
                        <Form.Item label="学历" name="education" rules={[{ required: true, message: '请选择学历!' }]}>
                            <Dropdown overlay={education_menu} placement="bottomCenter" arrow trigger='click'>
                                <Button type="primary" style={{marginRight:5}}>{this.state.education}</Button>
                            </Dropdown>
                        </Form.Item>
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="毕业院校" name="school" rules={[{required: true, message: '请输入毕业院校!'}]}>
                                <Input onChange={(e) => this.schoolChange(e.target.value)}/></Form.Item>
                        }
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="专业" name="major" rules={[{required: true, message: '请输入专业！'}]}>
                                <Input disabled={!this.state.ifHaveMajor}
                                       onChange={(e) => this.majorChange(e.target.value)}/></Form.Item>
                        }
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="劳动合同开始时间" name="startTime"
                                       rules={[{required: true, message: '请选择劳动合同开始时间!'}]}>
                                <Space direction="vertical" size={12}>
                                    <DatePicker
                                        format={'YYYY-MM-DD'}
                                        onChange={this.startTimeChange}
                                    />
                                </Space>
                            </Form.Item>
                        }
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="劳动合同结束时间" name="endTime"
                                       rules={[{required: true, message: '请选择劳动合同结束时间!'}]}>
                                <Space direction="vertical" size={12}>
                                    <DatePicker
                                        format={'YYYY-MM-DD'}
                                        onChange={this.endTimeChange}
                                    />
                                </Space>
                            </Form.Item>
                        }
                        <Form.Item label="所在部门" name="department" rules={[{ required: true, message: '请输入所在部门!' }]}>
                            <Input onChange={(e) => this.departmentChange(e.target.value)}/></Form.Item>
                        <Form.Item label="工作岗位" name="post" rules={[{ required: true, message: '请输入工作岗位!' }]}>
                            <Input onChange={(e) => this.postChange(e.target.value)}/></Form.Item>
                        {
                            (this.state.company.area === "青岛" || this.state.company.area === "山东其他地区") &&
                            <Form.Item label="是否科技人员" name="isTechnology"
                                       rules={[{required: true, message: '请选择是否科技人员!'}]}>
                                <Radio.Group name="radiogroup"
                                             onChange={(e) => this.isTechnologyChange(e.target.value)}>
                                    <Radio value={"是"}>是</Radio>
                                    <Radio value={"否"}>否</Radio>
                                </Radio.Group>
                            </Form.Item>
                        }
                        {/*<Form.Item label="是否参加社保" name="isInsured" rules={[{ required: true, message: '请选择是否参加社保!' }]}>*/}
                        {/*    <Radio.Group name="radiogroup"  onChange={(e) => this.isInsuredChange(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否兼职人员" name="isPartTime" rules={[{ required: true, message: '请选择是否兼职人员!' }]}>*/}
                        {/*    <Radio.Group name="radiogroup"  onChange={(e) => this.isPartTimeChange(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否临时聘用人员" name="isTemporary" rules={[{ required: true, message: '请选择是否临时聘用人员!' }]}>*/}
                        {/*    <Radio.Group name="radiogroup"  onChange={(e) => this.isTemporaryChange(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否退休返聘人员" name="isRetire" rules={[{ required: true, message: '请选择是否退休返聘人员!' }]}>*/}
                        {/*    <Radio.Group name="radiogroup"  onChange={(e) => this.isRetireChange(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否参加新农合" name="isNcms" rules={[{ required: true, message: '请选择是否参加新农合!' }]}>*/}
                        {/*    <Radio.Group name="radiogroup"  onChange={(e) => this.isNcmsChange(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否是新员工" name="isNew" rules={[{ required: true, message: '请选择是否是新员工!' }]}>*/}
                        {/*    <Radio.Group name="radiogroup"  onChange={(e) => this.isNewChange(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                        {/*<Form.Item label="是否是研究开发人员" name="isResearcher" rules={[{ required: true, message: '请选择是否是研究开发人员!' }]}>*/}
                        {/*    <Radio.Group name="radiogroup"  onChange={(e) => this.isResearcherChange(e.target.value)}>*/}
                        {/*        <Radio value={"是"}>是</Radio>*/}
                        {/*        <Radio value={"否"}>否</Radio>*/}
                        {/*    </Radio.Group>*/}
                        {/*</Form.Item>*/}
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.delete_visible}
                    title={'温馨提示'}
                    onOk={this.deleteStaff}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.deleteStaff}>
                            确定
                        </Button>,
                    ]}
                >
                    <div>确定删除该公司人员吗？</div>
                </Modal>
                <Modal
                    visible={this.state.preview_visible}
                    title={'预览'}
                    onCancel={this.hideModal}
                    destroyOnClose
                    width={'70%'}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                            下载
                        </Button>,
                    ]}
                >
                    <FileViewer fileType='pdf'
                                filePath={this.state.fileStream}
                                onError={this.onError}
                    />
                </Modal>
            </div>
        )
    }
    nameChange(e){
        this.setState({
            name:e
        })
    }
    idNumberChange(e){
        this.setState({
            idNumber:e
        })
    }
    titleChange(e){
        this.setState({
            title:e
        })
    }
    educationChange(e){
        if(e === '高中'||e === '初中'){
            this.setState({
                ifHaveMajor:false
            })
        }else{
            this.setState({
                ifHaveMajor:true
            })
        }
        this.setState({
            education:e
        })
    }
    schoolChange(e){
        this.setState({
            school:e
        })
    }
    majorChange(e){
        this.setState({
            major:e
        })
    }
    startTimeChange(value,dateString){
        this.setState({
            startTime:dateString
        })
    }
    endTimeChange(value,dateString){
        this.setState({
            endTime:dateString
        })
    }
    departmentChange(e){
        this.setState({
            department:e
        })
    }
    postChange(e){
        this.setState({
            post:e
        })
    }
    isTechnologyChange(e){
        this.setState({
            isTechnology:e
        })
    }
    isInsuredChange(e){
        this.setState({
            isInsured:e
        })
    }
    isPartTimeChange(e){
        this.setState({
            isPartTime:e
        })
    }
    isTemporaryChange(e){
        this.setState({
            isTemporary:e
        })
    }
    isRetireChange(e){
        this.setState({
            isRetire:e
        })
    }
    isNcmsChange(e){
        this.setState({
            isNcms:e
        })
    }
    // isNewChange(e){
    //     this.setState({
    //         isNew:e
    //     })
    // }
    // isResearcherChange(e){
    //     this.setState({
    //         isResearcher:e
    //     })
    // }
    nameChangeNew(e){
        this.setState({
            newName:e
        })
    }
    idNumberChangeNew(e){
        this.setState({
            newIdNumber:e
        })
    }
    titleChangeNew(e){
        this.setState({
            newTitle:e
        })
    }
    educationChangeNew(e){
        if(e === '高中'||e === '初中'){
            this.setState({
                ifHaveMajorNew:false,
                newMajor:''
            })
        }else{
            this.setState({
                ifHaveMajorNew:true
            })
        }
        this.setState({
            newEducation:e
        })
    }
    schoolChangeNew(e){
        this.setState({
            newSchool:e
        })
    }
    majorChangeNew(e){
        this.setState({
            newMajor:e
        })
    }
    startTimeChangeNew(value,dateString){
        this.setState({
            newStartTime:dateString
        })
    }
    endTimeChangeNew(value,dateString){
        this.setState({
            newEndTime:dateString
        })
    }
    departmentChangeNew(e){
        this.setState({
            newDepartment:e
        })
    }
    postChangeNew(e){
        this.setState({
            newPost:e
        })
    }
    isTechnologyChangeNew(e){
        this.setState({
            newIsTechnology:e
        })
    }
    isInsuredChangeNew(e){
        this.setState({
            newIsInsured:e
        })
    }
    isPartTimeChangeNew(e){
        this.setState({
            newIsPartTime:e
        })
    }
    isTemporaryChangeNew(e){
        this.setState({
            newIsTemporary:e
        })
    }
    isRetireChangeNew(e){
        this.setState({
            newIsRetire:e
        })
    }
    isNcmsChangeNew(e){
        this.setState({
            newIsNcms:e
        })
    }
    // isNewChangeNew(e){
    //     this.setState({
    //         newIsNew:e
    //     })
    // }
    // isResearcherChangeNew(e){
    //     this.setState({
    //         newIsResearcher:e
    //     })
    // }

}

export default StaffRoster;